import React, { useEffect } from 'react';
import { useHistory, useRouteMatch, Redirect, Switch, Route } from 'react-router-dom';
import { AccountSettingsContainer } from './settings/AccountSettingsContainer';
import { FAQ_PATH, HOME_PATH, SETTINGS_PATH } from '../react-router-paths';
import { IdleCheck } from '../shared/idleCheck/IdleCheck';
import { useGetUserInfoQuery, useSignOutUserMutation } from '../slices/account-api.slice';
import { AuthenticatedPageContainer } from '@workday/upc-common';
import { FallBack } from '../shared/loading-fallback/loading-fallback';
import { AppTiles } from './applications/app-tiles';
import { UpcFooter } from '../shared';
import { updateLocale } from '../../i18n';
import { WclAccountPanel } from './wcl-account-panel';
import { useSelector } from 'react-redux';
import { selectProfileImageUrl } from '../slices/profile-image.slice';

export function AccountContainer() {
    const [signOutUser, { isLoading, isSuccess }] = useSignOutUserMutation();
    const history = useHistory();
    const isHomePage = useRouteMatch({
        path: HOME_PATH,
        exact: true
    });

    const { data: userInfo } = useGetUserInfoQuery();
    const profileImageUrl = useSelector(selectProfileImageUrl);

    // set locale from userInfo object
    useEffect(() => {
        if (userInfo?.locale) {
            updateLocale(userInfo.locale);
        }
    }, [userInfo?.locale]);

    function onIdle() {
        signOutUser();
    }

    function onSignOutUser() {
        signOutUser();
    }

    function onLogoClick() {
        if (!isHomePage) {
            history.push(HOME_PATH);
        }
    }

    const fullName = userInfo?.firstName + ' ' + userInfo?.lastName;

    return isLoading || isSuccess || !userInfo ? (
        <FallBack />
    ) : (
        <IdleCheck onIdle={onIdle}>
            <AuthenticatedPageContainer
                profileImageUrl={profileImageUrl}
                faqUrl={FAQ_PATH}
                variant='inverse'
                onLogoClick={onLogoClick}
                footer={<UpcFooter isAuthenticated={true} />}
                menuContent={({ closeMenu }) => (
                    <WclAccountPanel
                        closeMenu={closeMenu}
                        email={userInfo.email}
                        username={fullName}
                        onSignOutClick={onSignOutUser}
                    />
                )}>
                <Switch>
                    <Route path={SETTINGS_PATH}>
                        <AccountSettingsContainer userInfo={userInfo} />
                    </Route>
                    <Route exact path={HOME_PATH}>
                        <AppTiles />
                    </Route>
                    <Redirect to={HOME_PATH} />
                </Switch>
            </AuthenticatedPageContainer>
        </IdleCheck>
    );
}
